<template lang="pug">
  div(:class="clase")
    .timeline-marker.is-primary
    .timeline-content
      p.heading
        b {{ titulo }}
      p {{ descripcion }}
      p(v-show='Number.isInteger(parseInt(movimiento.tipo))') 
        b 
          | Resguardo: 
        | {{ resguardo }}
      p 
        b 
          | Ubicacion: 
        | {{ ubicacion }}
      p(v-show="movimiento.source === 'mob'")
        b 
          | Teléfono: 
        | {{ equipo }}
      p 
        b 
          | Fecha Reg. : 
        | {{ fechaReg }}
</template>

<script>
export default {
  name: 'TimelineItem',
  props: {
    movimiento: {},
  },
  data () {
    return {
      clase: '',
      titulo: '',
      descripcion: '',
      resguardo: '',
      fechaReg:'',
      ubicacion:'',
      equipo: '',
    }
  },
  methods: {
    rellenarItem () {
      switch (this.movimiento.tipo) {
        case '0':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Alta de Artículo`
          this.descripcion = `El artículo fue dado de alta por ${this.movimiento.entrega}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '1':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Salida de Artículo`
          this.descripcion = `El artículo fue entregado por ${this.movimiento.entrega} a ${this.movimiento.recibe}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '2':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Asignación de Artículo`
          this.descripcion = `El artículo fue asignado por ${this.movimiento.entrega} a ${this.movimiento.recibe}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '3':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Préstamo de Artículo`
          this.descripcion = `El artículo fue prestado por ${this.movimiento.entrega} a ${this.movimiento.recibe}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '4':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Trasladando`
          this.descripcion = `El artículo se encuentra trasladando por ${this.movimiento.entrega} a ${this.movimiento.recibe}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '5':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Llegando a Almacén`
          this.descripcion = `El artículo ha llegado a Almacén destino, entregado por ${this.movimiento.entrega} a ${this.movimiento.recibe}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '6':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Reingreso Artículo`
          this.descripcion = `El artículo ha reingresado a Almacén, entregado por ${this.movimiento.entrega} a ${this.movimiento.recibe}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '7':
          this.clase = 'timeline-item is-primary'
          this.titulo = `En Pruebas`
          this.descripcion = `El artículo ha sido puesto en pruebas por ${this.movimiento.entrega} en ${this.movimiento.ubicacion} ${this.movimiento.oficina}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '9':
          this.clase = 'timeline-item is-primary'
          this.titulo = `En Reparación`
          this.descripcion = `El artículo ha sido puesto en reparación por ${this.movimiento.entrega} en ${this.movimiento.ubicacion} ${this.movimiento.oficina}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '8':
          this.clase = 'timeline-item is-primary'
          this.titulo = `Instalado`
          this.descripcion = `El artículo ha sido instalado por ${this.movimiento.entrega} en ${this.movimiento.ubicacion} ${this.movimiento.oficina}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '10':
          this.clase = 'timeline-item is-danger'
          this.titulo = `Desechado`
          this.descripcion = `El artículo ha sido desechado por ${this.movimiento.entrega}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case '11':
          this.clase = 'timeline-item is-info'
          this.titulo = `Obsequiado`
          this.descripcion = `El artículo ha sido obsequiado a ${this.movimiento.recibe}`
          this.equipo = `${this.movimiento.descripcion}`
          break
        case 't':
          switch (this.movimiento.momento) {
            case 0:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Ticket levantado`
              this.descripcion = `El Ticket fue levantado por ${this.movimiento.usuario}`
              break
            case 1:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Ticket atendido`
              this.descripcion = `El Ticket fue atendido por ${this.movimiento.usuario}`
              break
            case 3:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Compra Aceptada`
              this.descripcion = `La Compra ha sido aceptada por ${this.movimiento.usuario}`
              break
            case 5:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Compra Autorizada`
              this.descripcion = `La Compra ha sido autorizada por ${this.movimiento.usuario}`
              break
            case 6:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Compra en Requisición`
              this.descripcion = `La Compra ha sido pasada a requisición y orden de compra por ${this.movimiento.usuario}.`
              break
            case 7:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Gerente de planta ${this.movimiento.usuario}`
              break
            case 8:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Jefe de Área ${this.movimiento.usuario}`
              break
            case 9:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Gerente Administrativo ${this.movimiento.usuario}`
              break
            case 10:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Gerente General ${this.movimiento.usuario}`
              break
          
            default:
              break
          }
          break

        case 's':
          switch (this.movimiento.momento) {
            case 3:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Solicitud levantada`
              this.descripcion = `La solicitud fue levantada por ${this.movimiento.usuario}`
              break
            case 4:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Compra en Requisición`
              this.descripcion = `La Compra ha sido pasada a requisición y orden de compra por ${this.movimiento.usuario}.`
              break
            case 5:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Gerente de planta ${this.movimiento.usuario}`
              break
            case 6:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Jefe de Área ${this.movimiento.usuario}`
              break
            case 7:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Gerente Administrativo ${this.movimiento.usuario}`
              break
            case 8:
              this.clase = 'timeline-item is-primary'
              this.titulo = `Requisición Firmada`
              this.descripcion = `La Requisición ha sido firmada por Gerente General ${this.movimiento.usuario}`
              break
          
            default:
              break
          }
          break
        default:
          break
      }
      this.resguardo = this.movimiento.recibe
      this.fechaReg = this.movimiento.fechaReg
      this.ubicacion = this.movimiento.ubicacion
    }
  },
  created () {
    this.rellenarItem()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/TimelineItem.vue